import { render, staticRenderFns } from "./hosCulture.vue?vue&type=template&id=0958c47d&scoped=true&"
import script from "./hosCulture.vue?vue&type=script&lang=js&"
export * from "./hosCulture.vue?vue&type=script&lang=js&"
import style0 from "./hosCulture.vue?vue&type=style&index=0&id=0958c47d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0958c47d",
  null
  
)

export default component.exports